import api from "./api.service";
import { adminTokenService } from "./admin.token.service";
import { AdminDispatcher } from "./admin.dispatcher.service";

export interface AssignDispatcherToZoneData {
    idDispatcher: number;
    idZipcodeDispatchZone: number;
}

export interface UnassignDispatcherFromZoneData {
    idDispatcher: number;
    idZipcodeDispatchZone: number;
}

class AdminDispatcherZipcodeService {
    private getHeaders() {
        const token = adminTokenService.getAdminToken();
        return {
            Authorization: `${token}`,
        };
    }

    async getDispatchersByZone(idZone: number): Promise<{ statusCode: number; message: string; data: AdminDispatcher[] }> {
        try {
            const response = await api.get<{ statusCode: number; message: string; data: AdminDispatcher[] }>(
                `/admin/get-dispatchers-by-zone/${idZone}`,
                {
                    headers: this.getHeaders(),
                }
            );
            return response.data;
        } catch (error) {
            console.error(`Error fetching dispatchers for zone ${idZone}:`, error);
            throw error;
        }
    }

    async getAvailableDispatchersForZone(idZone: number): Promise<{ statusCode: number; message: string; data: AdminDispatcher[] }> {
        try {
            const response = await api.get<{ statusCode: number; message: string; data: AdminDispatcher[] }>(
                `/admin/get-available-dispatchers-for-zone/${idZone}`,
                {
                    headers: this.getHeaders(),
                }
            );
            return response.data;
        } catch (error) {
            console.error(`Error fetching available dispatchers for zone ${idZone}:`, error);
            throw error;
        }
    }

    async assignDispatcherToZone(data: AssignDispatcherToZoneData): Promise<any> {
        try {
            const response = await api.post(
                "/admin/assign-dispatcher-to-zone",
                data,
                {
                    headers: this.getHeaders(),
                }
            );
            return response.data;
        } catch (error) {
            console.error("Error assigning dispatcher to zone:", error);
            throw error;
        }
    }

    async unassignDispatcherFromZone(data: UnassignDispatcherFromZoneData): Promise<any> {
        try {
            const response = await api.post(
                "/admin/unassign-dispatcher-from-zone",
                data,
                {
                    headers: this.getHeaders(),
                }
            );
            return response.data;
        } catch (error) {
            console.error("Error unassigning dispatcher from zone:", error);
            throw error;
        }
    }
}

export const adminDispatcherZipcodeService = new AdminDispatcherZipcodeService();
